import React from 'react'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom'
import { all_routes } from '../../router/all_routes'

interface BannerProps {
    apiValues: any;
}



const Community: React.FC<BannerProps> = ({ apiValues }) => {

    const route = all_routes;
    return (
        <>
            {/* community-to-learn */}
            <section className="community-to-learn">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="section-header">
                                <span className="fw-medium text-secondary text-decoration-underline mb-2 d-inline-block">
                                    {apiValues?.secondHeadingText}
                                </span>
                                <h2>
                                    {apiValues?.secondHeadingDescription}
                                </h2>

                            </div>

                            {

                                (Array.isArray(apiValues?.secondCards) ? apiValues?.secondCards : []).map((univ: any, index: number) => {

                                    return (
                                        <div className="community-item d-flex align-items-center">
                                            {/* <span className="community-icon-2"> */}

                                            <ImageWithBasePath
                                                source={
                                                    univ?.imageUrl
                                                }
                                                style={{width: 40, height: 40}}
                                                className="rounded-full mr-2"
                                                // height={50}
                                                // width={50}
                                                alt="Img"
                                            />
                                            {/* </span> */}
                                            <div>
                                                <h5 className="mb-2">
                                                    {univ?.title}
                                                </h5>
                                                <p className="mb-0">
                                                    {univ?.description}
                                                </p>
                                            </div>
                                        </div>
                                    )
                                }) || []
                            }




                            <div className="flex items-center gap-2">
                                <Link
                                    to={route.Unlock}
                                    className="btn btn-md bg-[#EA1D2A] hover:bg-red-600 transition duration-300 text-white"
                                >
                                    {apiValues?.button1Text}
                                </Link>
                                <Link
                                    to={route.contact}
                                    className="btn btn-md bg-[#1D1753] hover:bg-indigo-800 transition duration-300 text-white"
                                >
                                    {apiValues?.button2Text}
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            {/* <div className="community-img d-none d-lg-flex"> */}

                            <ImageWithBasePath
                                source={
                                    apiValues?.secondRightSideImage
                                }
                                className=" mr-2"
                                // height={50}
                                // width={50}
                                alt="Img"
                            />

                            {/* <ImageWithBasePath
                                    src="assets/img/shapes/shape-5.png"
                                    alt="img"
                                    className="img-fluid community-img-01"
                                />
                              
                                <ImageWithBasePath
                                    src="assets/img/feature/feature-2.jpg"
                                    alt="img"
                                    className="img-fluid community-img-03"
                                />
                                <ImageWithBasePath
                                    src="assets/img/feature/feature-3.jpg"
                                    alt="img"
                                    className="img-fluid community-img-04"
                                /> */}


                            {/* </div> */}
                        </div>
                    </div>
                </div>
            </section>
            {/* /community-to-learn */}
        </>

    )
}

export default Community
